


































































import { EventBus } from '@/main/eventBus';
import { editFactory } from '@/main/pages';
import { Partner } from '@/modules/kartoteka/partner';
import { Fakturace } from '@/modules/uctenky/fakturace';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { DokladNaplnFakturaci, PlatbaTyp } from '@/modules/uctenky/fakturace/constants';
import { DOKLAD_TYP } from '@/modules/servis/doklad/constants';


import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { NAME } from './constants';
import { store } from './store/edit';
import { editMutations } from './store/types';

export default editFactory(NAME, store).extend({
	components: {
		ZakaznikSelect: Partner.components.Select,
		DmsPdfDialog,
	},
	data() {
		return {
			mutationsMappers: {
				zakaznik: `${this.storeUri}/${editMutations.ZAKAZNIK_SELECT_MAPPER}`,
			},
			tiskDialog: {
				visible: false,
				filter: null as {} | null,
				fetchPdfProvider: null as (() => Promise<any>) | null,
			},
		};
	},
	computed: {
		dokladExists(): boolean {
			return !!this.DokladovId;
		},
		diableDobropis(): boolean {
			return (this.DokladDruh !== DOKLAD_TYP.DD_OV && this.DokladDruh !== DOKLAD_TYP.DD1_OV) || this.PlatbaPzn === PlatbaTyp.DONT_PAY;
		},
	},
	watch: {
		canProcess(newVal) {
			if (newVal) {
				EventBus.$emit('DisableAll', true);
			}
		},
	},
	methods: {
		tiskKopie() {
			this.tiskDialog.filter = { dokladId: this.DokladovId!, nahled: false };
			this.tiskDialog.fetchPdfProvider = () => Fakturace.apiProvider.tvorbaKopie({ dokladovId: this.DokladovId! }, false);
			this.tiskDialog.visible = true;
		},
		tiskDobropisu() {
			openEdit(Fakturace.name, PageMode.CREATE, {
				filter: { doklad3Id: this.Doklad3Id, dokladovId: this.DokladovId, dokladNaplnFakturaci: DokladNaplnFakturaci.DOBROPIS },
			});
		},
		storno() {
			this.tiskDialog.fetchPdfProvider = () => Fakturace.apiProvider.tvorbaDobropisuPrima({
				dokladovId: this.DokladovId!, dokladNaplnFakturaci: DokladNaplnFakturaci.STORNO,
			});
			this.tiskDialog.visible = true;
		},
	},
});
